






























































































































import VueOptions from '@utils/VueOptions'
import EditorContent from '@components/EditorContent'
import EventBrandPartners from '@modules/ui/Event/EventBrandPartners'
import Team from '@modules/ui/Event/sections/Team'

settings = 
  name: 'EventOverviewSection'

  vue:
    props: ['event', 'canEdit']
    components: { EventBrandPartners, Team, EditorContent }

    computed:
      eventSpacesAsArray: () ->
        return [] unless @event?.spaces?
        arrayed = []
        arrayed.push(obj) for key, obj of @event.spaces
        arrayed
      mapOptions: ->
        draggable: false
        zoomControl: false
        mapTypeControl: false
        scaleControl: false
        streetViewControl: false
        rotateControl: false
        fullscreenControl: false
        disableDefaultUi: true
      spaces: ->
        sampling: @eventSpacesAsArray.filter((e) -> e.category == 'sampling')
        booths: @eventSpacesAsArray.filter((e) -> e.category == 'booth')
        trucks: @eventSpacesAsArray.filter((e) -> e.category == 'truck')
        media: @eventSpacesAsArray.filter((e) -> e.category == 'media')
        nativeIntegration: @eventSpacesAsArray.filter((e) -> e.type == 'native_integration')
        socialPosts: @eventSpacesAsArray.filter((e) -> e.type == 'social_media_post')

      partnerShareLink: -> @ctxPartnerShareLink(@event)
      partnerShareLinkPath: -> "#{window.location.origin}/#{@partnerShareLink}"

    methods:
      imageForSpaceType: (type)->  "#{process.env.VUE_APP_IMAGE_ENDPOINT}/spaces/#{type}.png"
      fieldIsMissing: (fields) ->
        return false unless @event.missing_required_fields?
        missing = false
        missing = @event.missing_required_fields.includes(fields) if !Array.isArray(fields)
        missing ||= @event.missing_required_fields.includes(field) for field in fields if Array.isArray(fields) 
        missing

      hiCopyToClipboard: (event) ->
        @copyToClipboard event, @partnerShareLinkPath
        @showFlash { 'Message:': 'Copied to clipboard' }

export default VueOptions.vue settings
